// // Event listener for the play/pause button
// $("#play_button").click(function() {
//   var video = document.getElementById("video"); // Assuming you have a video element with id "video"
//   if (video.paused === true) {
//     // Play the video
//     video.play();
//     // Update the button text to 'Pause'
//     $(this).html("Pause").attr("id", "pause_button");
//   } else {
//     // Pause the video
//     video.pause();
//     $("#pause_button").attr("id", "play_button");
//     // Update the button text to 'Play'
//     $(this).html("Play");
//   }
// });

// $("#video").on("ended", function() {
//   // What you want to do after the video ends
//   $("#pause_button").attr("id", "play_button");
//   $("#play_button").html("Play");
// });


// upsell js in cart drawer

$(document).ready(function(){
$(document).on('click', '.addcart-btn',function(){
  var pro_id = $(this).data("pro-id");
  let arr = [];
  arr.push({id: pro_id, quantity: 1 });   
  let formData = {'items': arr};
  fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            }).then((response) => {
              return response.json();
            }).then((res) => {
    document.dispatchEvent(new CustomEvent('cart:build'));
     document.dispatchEvent(new CustomEvent('cart:updated'));
// setTimeout(function(){
//   console.log($(".upsell-pro-list").length);
//     if($(".upsell-pro-list").length < 1)
//     {.js
//       $(".upsell_products_drawer").css("display","none");
//     }
//   },500);
            if(res.status && res.status == 422){
              console.log("Inventory Error !");
            }else{
              console.log("Success !");
              }
            }).catch((err) => {
              /* uh oh, we have error. */
              console.error(err)
            });
});
});


  


$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs a').click(function(){
  
     $('.panel').hide();
     $('.tabs a.active').removeClass('active');
     $(this).addClass('active');
     
     var panel = $(this).attr('href');
     $(panel).fadeIn(1000);
     
     return false;  // prevents link action
    
  });  // end click 

     $('.tabs li:first a').click();
     
}); // end ready




